import type { Project } from '../api';
import { Select } from './ui';

export default function ProjectPicker({
  projects,
  value,
  onChange,
  showUnassigned,
}: {
  projects: Project[];
  value: string;
  onChange: (value: string) => void;
  showUnassigned?: boolean;
}) {
  return (
    <Select aria-label="Project" value={value} onChange={(e) => onChange(e.target.value)}>
      {projects.map((p) => (
        <option key={p.id} value={p.id}>
          {p.name}
        </option>
      ))}
      {showUnassigned && <option value="unassigned">Unassigned devices</option>}
    </Select>
  );
}
